import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import WebFont from 'webfontloader';
var options = {
  "google": {
    "families": ["Open+Sans:400,600,700&display=swap"]
  }
};
WebFont.load(options);